import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postInsertReschedule = async (id, formData) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `productivity-host/reschedule/${id}`,
    data: formData,
  });

  return data?.data;
};

export default postInsertReschedule;
